import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import React from "react";
import { ComboBoxContext } from "./ComboBoxContext";
import cls from "./combo-box.module.scss";
export const DropdownVirtualItem = (props) => {
    // console.count(`Render ComboListItem ${index}`);
    const { item, index, textField, valueField, renderItem, itemHeight, style, } = props;
    const ref = React.useRef(null);
    const context = React.useContext(ComboBoxContext);
    const { subscribe, isIndexHighlighted, setHighlightedIndexByMouse, setSelectedIndex, isItemSelected, dropdownItemClass, dropdownItemStyle, dropdownSelectedItemClass, dropdownSelectedItemStyle, dropdownHighlightedItemClass, dropdownHighlightedItemStyle, } = context;
    const isSelected = isItemSelected(index);
    const isHighlighted = React.useSyncExternalStore(subscribe, () => isIndexHighlighted(index));
    const itemStyle = {
        ...dropdownItemStyle,
        ...((isHighlighted && !isSelected) ? dropdownHighlightedItemStyle : undefined),
        ...(isSelected ? dropdownSelectedItemStyle : undefined),
        ...style
    };
    const itemClass = classNames(dropdownItemClass, cls.item, { [dropdownSelectedItemClass ?? cls.selectedItem]: isSelected }, { [dropdownHighlightedItemClass ?? cls.highlightedItem]: isHighlighted && !isSelected });
    //https://www.npmjs.com/package/@faceless-ui/mouse-info
    const onMouseOver = () => {
        setHighlightedIndexByMouse(index);
    };
    const onMouseUp = () => {
        setSelectedIndex(index);
    };
    const onMouseDown = (e) => {
        e.preventDefault();
    };
    return _jsx("div", { ref: ref, style: itemStyle, className: itemClass, "data-index": index, onMouseOver: onMouseOver, onMouseDown: onMouseDown, onMouseUp: onMouseUp, children: renderItem({ item, textField, valueField, itemHeight, isSelected }) });
};
